import { InputLabel, Select } from '@material-ui/core';
import React, { useState } from 'react';
import InputMask from 'react-input-mask';
import { connect, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import HeaderPage from '~/components/HeaderPage';
import { ApplicationState } from '~/store';
import { api } from '../../services/api';
import {
  ConfirmButton,
  Container,
  FormControlLGPD,
  SearchButton,
  StyledTextField,
} from './styles';

interface CategoriaProps {
  data_holder_cat_id: number;
  data_holder_cat_name: string;
  country_company_id: number;
}

interface TitularProps {
  identification_key: string;
  ownership_type: number;
  username: string;
}

type CategoriaData = {
  value: string;
};

interface InputReference extends InputMask {
  value: string;
}

interface SelectReference extends HTMLSelectElement {
  value: string;
}

interface DisableConfirm {
  isDisabled: boolean;
}

export function Anominizacao() {
  const { company, token } = useSelector<ApplicationState, any>(
    state => state.auth,
  );

  const categorias = [
    {},
    ...useSelector<ApplicationState, any>(state => state.common.categorias),
  ] as CategoriaProps[];

  const [formErr, setFormErr] = useState<any>({});
  const [titular, setTitular] = useState<TitularProps>({} as TitularProps);
  const [disable, setDisable] = useState<DisableConfirm>({ isDisabled: true });
  const [identityTypeId, setIdentityTypeId] = useState('');
  const [categoria, setCategoria] = useState<CategoriaData>({
    value: '',
  } as CategoriaData);

  const isValidIdentityTypeId = (identityTypeId: string) => {
    if (identityTypeId) {
      setFormErr({
        ...formErr,
        identification_key: identityTypeId.length < 14,
      });
    }

    setIdentityTypeId(identityTypeId);
  };

  const isValidCategoria = (categoria: string) => {
    if (categoria) {
      setFormErr({
        ...formErr,
        ownership_type: categoria === '',
      });
    }

    setCategoria({ value: categoria });
  };

  const isVerifyField = (
    inputRefValue: string | undefined,
    selectRefValue: number,
  ) => {
    if (!inputRefValue || selectRefValue <= 0) {
      toast.error('Todos os campos devem ser preenchidos.');
      return true;
    }
    return false;
  };

  const handleSubmits = async () => {
    let categoriaSelecionada = 0;
    if (categoria.value !== '' && categoria.value !== undefined) {
      categoriaSelecionada = parseInt(categoria.value);
    }

    setFormErr({
      ...formErr,
      identification_key: identityTypeId === null || identityTypeId === '',
      ownership_type: categoriaSelecionada === 0,
    });

    if (isVerifyField(identityTypeId, categoriaSelecionada)) return;

    await api
      .get(`/v1/titulares/titular`, {
        params: {
          identityTypeId,
          dataHolderCatId: categoriaSelecionada,
        },
        headers: {
          'content-type': 'application/json',
          company: company?.country_company_id,
          Authorization: `Bearer ${token}`,
        },
      })
      .then(response => {
        setDisable({ isDisabled: false });
        setTitular(response.data);
      })
      .catch(error => {
        if (error.response) {
          toast.error(error.response.data.message);
        }
        setDisable({ isDisabled: true });
      });
  };

  const handleAnonymization = async () => {
    let categoriaSelecionada = 0;
    if (categoria.value) {
      categoriaSelecionada = parseInt(categoria.value);
    }

    if (isVerifyField(identityTypeId, categoriaSelecionada)) return;

    await api
      .post(
        `/v1/anonimizacao`,
        {
          ownershypType: titular.ownership_type,
          identity: titular.identification_key,
        },
        {
          headers: {
            'content-type': 'application/json',
            company: company?.country_company_id,
            Authorization: `Bearer ${token}`,
          },
        },
      )
      .then(() => {
        toast.success('Titular anonimizado.');
      })
      .catch(error => {
        if (error.response) {
          toast.error(error.response.data.message);
        }
      });

    setIdentityTypeId('');
    setCategoria({ value: '' });
    setTitular({ identification_key: '', username: '', ownership_type: 0 });
  };

  return (
    <div>
      <Container>
        <HeaderPage pageTitle="Anonimizar dados do titular" />

        <div className="main-content-anonimizacao">
          <h1>Insira os dados do titular</h1>

          <div className="search-of-titles">
            <InputMask
              mask="999.999.999-99"
              name="identification_key"
              disabled={false}
              value={identityTypeId}
              maskChar=""
              onChange={e => isValidIdentityTypeId(e.target.value)}
              children={() => (
                <StyledTextField
                  identificationKeyError={
                    !!formErr?.identification_key ? true : false
                  }
                  name="identification_key"
                  id="identificationKey"
                  label="CPF do titular"
                  variant="outlined"
                  className="InputMask-lgpd"
                />
              )}
            />
            <FormControlLGPD
              variant="outlined"
              ownershipTypeError={!!formErr?.ownership_type ? true : false}
              isLegendvisibility={categoria.value === '' ? false : true}
            >
              <InputLabel
                htmlFor="outlined-ownershipType-native-simple"
                shrink={categoria.value === '' ? false : true}
              >
                Categoria
              </InputLabel>
              <Select
                onChange={e => {
                  isValidCategoria(e.target.value as string);
                }}
                value={categoria.value}
                name="data_holder_cat_name"
                native
                label="Categoria"
                inputProps={{
                  name: 'data_holder_cat_id',
                  id: 'data_holder_cat_id',
                }}
              >
                {categorias.map(categoria => {
                  return (
                    <option
                      key={categoria.data_holder_cat_id}
                      value={categoria.data_holder_cat_id}
                    >
                      {categoria.data_holder_cat_name}
                    </option>
                  );
                })}
              </Select>
            </FormControlLGPD>

            <SearchButton type="submit" onClick={handleSubmits}>
              Pesquisar
            </SearchButton>
          </div>

          <div className="date-of-holder">
            <div className="date-searched">
              <InputMask
                mask="999.999.999-99"
                value={titular.identification_key}
                disabled={true}
                name="identification_key"
                maskChar=""
                children={() => (
                  <StyledTextField
                    name="identification_key"
                    id="identificationKey"
                    label="CPF do titular"
                    variant="outlined"
                    className="InputMask-lgpd-holder"
                    disabled={true}
                  />
                )}
              />

              <StyledTextField
                disabled={true}
                id="titular"
                label="Nome do titular"
                name="title"
                variant="outlined"
                className="TextField-lgpd"
                value={titular.username}
              />
            </div>
            <div className="confirm-lgpd">
              <ConfirmButton
                className="button-confirm-lgpd"
                onClick={handleAnonymization}
                disabled={disable.isDisabled}
              >
                Confirmar
              </ConfirmButton>
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
}

function mapStateToProps(state: any) {
  return state;
}

export default connect(mapStateToProps)(Anominizacao);
